export default __webpack_public_path__ + "static/media/flaim.57f2dc22.png";